import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Zap, Download } from 'lucide-react';
export function WhatYouGet() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  const items = [{
    icon: BookOpen,
    title: 'RECETARIO PRINCIPAL +500 RECETAS',
    description: 'Un recetario digital completo con una enorme variedad de recetas pensadas para disfrutar sin azúcar y sin gluten.',
    bullets: ['desayunos', 'snacks', 'meriendas', 'postres', 'almuerzos', 'cenas', 'bebidas', 'opciones rápidas para el día a día'],
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=600&h=400&fit=crop'
  }, {
    icon: Zap,
    title: 'RECETAS FÁCILES Y PRÁCTICAS',
    description: 'Todas las recetas están pensadas para que puedas seguirlas de forma simple, incluso si no tenés experiencia cocinando.',
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=600&h=400&fit=crop'
  }, {
    icon: Download,
    title: 'ACCESO DIGITAL INMEDIATO',
    description: 'Recibís el material al instante y podés verlo desde tu celular, tablet o computadora.',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&h=400&fit=crop'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-196">
      <div className="max-w-6xl mx-auto" data-id="element-197">
        <motion.h2 {...fadeInUp} className="font-playfair text-3xl md:text-5xl font-bold text-center text-dark mb-12" data-id="element-198">
          ¿Qué vas a recibir hoy?
        </motion.h2>

        <div className="space-y-12" data-id="element-199">
          {items.map((item, index) => <motion.div key={index} {...fadeInUp} transition={{
          delay: index * 0.1
        }} className={`grid md:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`} data-id="element-200">
              <div className={index % 2 === 1 ? 'md:order-2' : ''} data-id="element-201">
                <div className="flex items-center gap-3 mb-4" data-id="element-202">
                  <div className="bg-primary/10 p-3 rounded-lg" data-id="element-203">
                    <item.icon className="w-8 h-8 text-primary" data-id="element-204" />
                  </div>
                  <h3 className="font-playfair text-2xl font-bold text-dark" data-id="element-205">
                    {item.title}
                  </h3>
                </div>

                <p className="text-lg text-dark/80 mb-4 leading-relaxed" data-id="element-206">
                  {item.description}
                </p>

                {item.bullets && <div className="bg-cream p-6 rounded-lg" data-id="element-207">
                    <p className="font-semibold mb-3" data-id="element-208">Incluye ideas para:</p>
                    <ul className="grid grid-cols-2 gap-2" data-id="element-209">
                      {item.bullets.map((bullet, i) => <li key={i} className="flex items-center gap-2 text-dark/70" data-id="element-210">
                          <span className="w-1.5 h-1.5 bg-primary rounded-full" data-id="element-211"></span>
                          {bullet}
                        </li>)}
                    </ul>
                  </div>}
              </div>

              <div className={index % 2 === 1 ? 'md:order-1' : ''} data-id="element-212">
                <img src={item.image} alt={item.title} className="rounded-xl shadow-lg w-full h-auto" data-id="element-213" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}